import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CcsTextareaComponent } from '@shared/components';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-generic-modal-notes',
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    CcsTextareaComponent,
    DatePipe,
  ],
  templateUrl: './generic-modal-notes.component.html',
  styleUrls: ['./generic-modal-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericModalNotesComponent {
  private readonly _fb = inject(NonNullableFormBuilder);

  protected form = this._fb.group({
    content: this._fb.control('', Validators.required),
    is_public: this._fb.control(false, []),
  });

  protected readonly today: Date = new Date();

  get formValue() {
    return this.form.getRawValue();
  }
}
